import _sfc_main$1 from "./code_editor_tag.vue.js";
import { createBlock, createElementVNode, openBlock, withCtx } from "vue";
//#region src/components/code_editor/code_editor_closing_tag.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcCodeEditorClosingTag" }, {
	props: { name: {
		type: String,
		required: true
	} },
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(_sfc_main$1, { name: __props.name }, {
				start: withCtx(() => [..._cache[0] || (_cache[0] = [createElementVNode("span", null, "/", -1)])]),
				_: 1
			}, 8, ["name"]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=code_editor_closing_tag.vue.js.map